import { render } from "./vh-query-badge.vue?vue&type=template&id=24dc3ff5"
import script from "./vh-query-badge.vue?vue&type=script&lang=js"
export * from "./vh-query-badge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__